import { apiInstance } from "@/api/instance";

export default async function (reviewId) {
  return apiInstance.get(`/review/${reviewId}`);
}
